import React, { Component } from "react";

export default class PaymentHistory extends Component {
  render() {
    return (
      <div>PAYMENT HISTORY (FINANCE={this.props.match.params.financeId})</div>
    );
  }
}
